import React from 'react';
import StaticPageWrapper from '../StaticPageWrapper';
import image from './privacyimg.png';
import styles from './styles.module.css';
const PrivacyPolicies = () => {
  return (
    <StaticPageWrapper img={image} title={"PRIVACY POLICY"}>
      <div>
        <p className={styles.title}>Disclosure Of Your Personal Data</p>
        <p className={styles.text}>
          We value the trust you place in us. That’s why we insist upon the highest standards for secure transactions
          and customer information privacy. Please read the following statement to learn about our information gathering
          and dissemination practices.
        </p>

        <p className={styles.title}>Note</p>
        <p className={styles.text}>
          Our privacy policy is subject to change at any time without notice. To make sure you are aware of any changes,
          please review this policy periodically.
          <br />
          <br />
          By visiting this Website you agree to be bound by the terms and conditions of this Privacy Policy. If you do
          not agree please do not use or access our Website.
          <br />
          <br />
          By mere use of the Website, you expressly consent to our use and disclosure of your personal information in
          accordance with this Privacy Policy. This Privacy Policy is incorporated into and subject to the Terms of Use.
        </p>

        <p className={styles.title}>Collection Of Personally Identifiable Information And Other Information</p>
        <p className={styles.text}>
          When you use our Website, we collect and store your personal information which is provided by you from time to
          time. Our primary goal in doing so is to provide you a safe, efficient, smooth and customized experience. This
          allows us to provide services and features that most likely meet your needs, and to customize our Website to
          make your experience safer and easier. More importantly, while doing so we collect personal information from
          you that we consider necessary for achieving this purpose.
          <br />
          <br />
          In general, you can browse the Website without telling us who you are or revealing any personal information
          about yourself. Once you give us your personal information, you are not anonymous to us. Where possible, we
          indicate which fields are required and which fields are optional. You always have the option to not provide
          information by choosing not to use a particular service or feature on the Website. We may automatically track
          certain information about you based upon your behaviour on our Website. We use this information to do internal
          research on our users’ demographics, interests, and behaviour to better understand, protect and serve our
          users. This information is compiled and analysed on an aggregated basis. This information may include the URL
          that you just came from (whether this URL is on our Website or not), which URL you next go to (whether this
          URL is on our Website or not) and your computer browser information.
        </p>

        <p className={styles.title}>Cookies And Collection Of Personal Date</p>
        <p className={styles.text}>
          We use data collection devices such as “cookies” on certain pages of the Website to help analyse our web page
          flow, measure promotional effectiveness, and promote trust and safety. “Cookies” are small files placed on
          your hard drive that assist us in providing our services. We offer certain features that are only available
          through the use of a “cookie”.
          <br />
          <br />
          We also use cookies to allow you to enter your password less frequently during a session. Cookies can also
          help us provide information that is targeted to your interests. Most cookies are “session cookies,” meaning
          that they are automatically deleted from your hard drive at the end of a session. You are always free to
          decline our cookies if your browser permits, although in that case you may not be able to use certain features
          on the Website and you may be required to re-enter your password more frequently during a session.
          <br />
          <br />
          Additionally, you may encounter “cookies” or other similar devices on certain pages of the Website that are
          placed by third parties. We do not control the use of cookies by third parties. If you choose to buy on the
          Website, we collect information about your buying behavior. If you choose to post messages on our message
          boards, chat rooms or other message areas or leave feedback, we will collect that information you provide to
          us. We retain this information as necessary to resolve disputes, provide customer support and troubleshoot
          problems as permitted by law.
          <br />
          <br />
          If you send us personal correspondence, such as emails or letters, or if other users or third parties send us
          correspondence about your activities or postings on the Website, we may collect such information into a file
          specific to you.
          <br />
          <br />
          We collect personally identifiable information (email address, name, phone number, IBAN Number details, etc.)
          from you when you set up a free account with us. We do use your contact information to send you offers based
          on your previous orders and your interests. You are required to submit Your information at the time of making
          an online purchase on the Website. Umrahme.com or B2b.umrahme.com uses GDS Payment Mechanism that is operated
          by a GDS and the information that You share with Umrahme.com or B2b.umrahme.com is transferred and shared with
          GDS.
        </p>

        <p className={styles.title}>Use Of Demographic / Profile Data / Your Information</p>
        <p className={styles.text}>
          We identify and use your IP address to help diagnose problems with our server, and to administer our Website.
          Your IP address is also used to help identify you and to gather broad demographic information.
          <br />
          <br />
          We use personal information to provide the services you request. To the extent we use your personal
          information to market to you, we will provide you the ability to opt-out of such uses. We use your personal
          information to resolve disputes; troubleshoot problems; help promote a safe service; measure consumer interest
          in our products and services, inform you about online offers, products, services, and updates; customize your
          experience; detect and protect us against error, fraud and other criminal activity; enforce our terms and
          conditions; and as otherwise described to you at the time of collection.
          <br />
          <br />
          We will occasionally ask you to complete optional online surveys or fill in details which are part of our KYC
          process. These surveys may ask you for contact information and demographic information (like city, country,
          other details, etc.). We use this data to tailor your experience at our Website, providing you with content
          that we think you might be interested in and to display content according to your preferences.
          <br />
          <br />
          In our efforts to continually improve our product and service offerings, we collect and analyse demographic
          and profile data about our users’ activity on our Website.
        </p>
      </div>
    </StaticPageWrapper>
  );
};

export default PrivacyPolicies;
